export enum CommonEventFieldKeys {
    ResourceType = "Resource Type",
    ActionType = "Action Type",
    Source = "Source",
}
